import { Component, OnInit, AfterViewInit, PLATFORM_ID, Inject } from '@angular/core';
import { isPlatformBrowser, isPlatformServer } from '@angular/common';
import { Title, Meta } from '@angular/platform-browser';
import * as $ from 'jquery';
import { LinkService } from '../../../_services/langhfre.service';
//declare function ire(string,{}): any;
@Component({
  selector: 'app-citation-checker',
  templateUrl: './citation-checker.component.html',
  styleUrls: ['./citation-checker.component.scss']
})
export class CitationCheckerComponent implements OnInit, AfterViewInit {

  constructor(
    private titleService: Title,
    private metaTagService: Meta,
    @Inject(PLATFORM_ID) private platformId: Object,
    private LinkService: LinkService
  ) { }

  ngOnInit() {
    this.titleService.setTitle('Trinka引用チェッカー｜参考文献/引用文献の分析で、論文に強固な論証を');
    this.metaTagService.updateTag({ name: 'description', content: "Trinkaの引用チェッカーを使えば、有力な論文の引用が可能になり、査読者の否定的なフィードバックを回避し、論証の質を向上できます。" });
    this.metaTagService.updateTag({ property: 'og:title', content: 'Trinka引用チェッカー｜参考文献/引用文献の分析で、論文に強固な論証を' });
    this.metaTagService.updateTag({ property: 'og:description', content: "Trinkaの引用チェッカーを使えば、有力な論文の引用が可能になり、査読者の否定的なフィードバックを回避し、論証の質を向上できます。" });
    this.metaTagService.updateTag({ property: 'og:url', content: 'https://www.trinka.ai/jp/features/citation-checker' });
    this.metaTagService.updateTag({ property: 'og:type', content: 'website' });
    this.metaTagService.updateTag({ property: 'og:image', content: 'https://www.trinka.ai/assets/images/features/s2.svg' });
    this.metaTagService.updateTag({ name: 'twitter:title', content: 'Trinka引用チェッカー｜参考文献/引用文献の分析で、論文に強固な論証を' });
    this.metaTagService.updateTag({ name: 'twitter:description', content: "Trinkaの引用チェッカーを使えば、有力な論文の引用が可能になり、査読者の否定的なフィードバックを回避し、論証の質を向上できます。" });
    this.metaTagService.updateTag({ name: 'twitter:image', content: 'https://trinka.ai/assets/images/features/s2.svg' });
    this.metaTagService.updateTag({ name: 'language', content: 'ja-jp' });
    this.LinkService.addTag({ rel: 'canonical', href: 'https://www.trinka.ai/jp/features/citation-checker' });
    this.LinkService.addTag({ rel: 'alternate', hreflang: 'x-default', href: 'https://www.trinka.ai/features/citation-checker' });
    this.LinkService.addTag({ rel: 'alternate', hreflang: 'en-us', href: 'https://www.trinka.ai/features/citation-checker' });
    this.LinkService.addTag({ rel: 'alternate', hreflang: 'ja-jp', href: 'https://www.trinka.ai/jp/features/citation-checker' });
    this.LinkService.addTag({ rel: 'alternate', hreflang: 'zh-cn', href: 'https://trinka.enago.cn/features/citation-checker' });
    this.LinkService.addTag({ rel: 'alternate', hreflang: 'zh-tw', href: 'https://www.trinka.ai/tw/features/citation-checker' });
    // this.LinkService.addTag({ rel: 'alternate', hreflang: 'ko-kr', href: 'https://www.trinka.ai/kr/features/citation-checker' });
    this.LinkService.addTag({ rel: 'alternate', hreflang: 'es-es', href: 'https://www.trinka.ai/es/features/citation-checker' });
    this.LinkService.addTag({ rel: 'alternate', hreflang: 'pt-pt', href: 'https://www.trinka.ai/pt/features/citation-checker' });
    if (isPlatformBrowser(this.platformId)) {
      // $.getScript('../../../assets/js/particles.min.js', function(){});
      $.getScript('../../../assets/js/wisepop.js', function () { });
    }
    //ire('identify', {'customerId':'', customerEmail: '', customProfileId: this.generateGuid()});
  }
  scroll(el: HTMLElement) {
    el.scrollIntoView({ behavior: 'smooth' });
  }
  ngAfterViewInit() {
    if (isPlatformBrowser(this.platformId)) {
      $('#closedPopup, #wordPluginPopup').click(function () {
        $('iframe.youtubeVideoForTryDemo').remove()
      });

      $('#VewiVideoSection').click(function () {
        if (!$('#iframe').length) {
          $('#iframeHolder').html('<iframe class="youtubeVideoForTryDemo" id="iframe" src="https://www.youtube.com/embed/XBuFdCM3xtk" width="100%" height="450"></iframe>');
        }
      });

    }
  }

  
}
